import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import supabase from "../supabase";
import HomeNav from "./HomeNav";
import { EyeIcon, EyeOffIcon } from "./icons/EyeIcon";
import {
  validatePassword,
  PASSWORD_REQUIREMENTS_TEXT,
} from "../lib/validatePassword";

const SetPassword = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");

  // Extract token and email from the URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenHash = (
      params.get("token") ||
      params.get("token_hash") ||
      ""
    ).trim();
    const emailParam = (params.get("email") || "").trim().toLowerCase();
    const roleParam = (params.get("role") || "").trim();

    console.log("Extracted token:", tokenHash);
    console.log("Extracted email:", emailParam);
    console.log("Extracted role:", roleParam);

    setToken(tokenHash);
    setEmail(emailParam);
    setRole(roleParam);
  }, [location]);

  const handleSetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!token || !email) {
        alert("Invalid invite link.");
        setLoading(false);
        return;
      }

      const passwordError = validatePassword(password);
      if (passwordError) {
        alert(passwordError);
        setLoading(false);
        return;
      }

      // Look up the invite
      const { data: invite, error: inviteError } = await supabase
        .from("Invites")
        .select("*")
        .eq("email", email)
        .eq("token", token)
        .maybeSingle();

      console.log("Invite result:", invite, inviteError);

      if (inviteError || !invite) {
        alert("Invite not found or already used. Please contact support.");
        setLoading(false);
        return;
      }

      // Create Supabase Auth user + Users row via your server (auto-confirmed)
      const resp = await fetch(
        process.env.NODE_ENV === "production"
          ? "/api/create-user"
          : "http://localhost:5000/api/create-user",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            password,
            name: invite.name,
            role: invite.role,
            company_id: invite.company,
            token,
          }),
        }
      );

      const payload = await resp.json();
      if (!resp.ok) {
        console.error("create-user failed:", payload);
        alert(payload.error || "Failed to create user");
        setLoading(false);
        return;
      }

      // Delete or mark invite used
      const { error: deleteError } = await supabase
        .from("Invites")
        .delete()
        .eq("email", email)
        .eq("token", token);

      if (deleteError) console.warn("Error deleting invite:", deleteError);

      alert("Account created successfully!");
      navigate("/login");
    } catch (err) {
      console.error("Error during set password:", err);
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const divStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "80px",
    paddingBottom: "80px",
    backgroundColor: "#3a886f",
    minHeight: "95vh",
  };

  return (
    <div>
      <HomeNav />
      <div style={divStyle}>
        <div className="login-container">
          <img className="login-logo" src="/Long_Black_Transparent.png" />
          <h1 className="login-header">Set Password</h1>
          <form onSubmit={handleSetPassword} className="login-form">
            <input
              type="email"
              value={email}
              readOnly
              style={{ opacity: 0.6 }}
            />
            <div
              style={{
                position: "relative",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type={showPassword ? "text" : "password"}
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  display: "block",
                  width: "100%",
                  paddingRight: "40px",
                  boxSizing: "border-box",
                  marginBottom: 0,
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: 0,
                  bottom: 0,
                  margin: "auto 0",
                  height: "18px",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 10 }}>
              {PASSWORD_REQUIREMENTS_TEXT}
            </div>
            <button type="submit" disabled={loading}>
              {loading ? "Setting Password..." : "Set Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
